/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  MetaFactory,
  MetaFactoryInterface,
} from "../../contracts/MetaFactory";

const _abi = [
  {
    inputs: [],
    name: "UnequalArrayLengths",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "daoAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "accessControl",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
    ],
    name: "DAOCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "bytes[]",
        name: "calldatas",
        type: "bytes[]",
      },
    ],
    name: "Executed",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "daoFactory",
        type: "address",
      },
      {
        components: [
          {
            internalType: "address",
            name: "daoImplementation",
            type: "address",
          },
          {
            internalType: "address",
            name: "accessControlImplementation",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "salt",
            type: "bytes32",
          },
          {
            internalType: "string",
            name: "daoName",
            type: "string",
          },
          {
            internalType: "string[]",
            name: "roles",
            type: "string[]",
          },
          {
            internalType: "string[]",
            name: "rolesAdmins",
            type: "string[]",
          },
          {
            internalType: "address[][]",
            name: "members",
            type: "address[][]",
          },
          {
            internalType: "string[]",
            name: "daoFunctionDescs",
            type: "string[]",
          },
          {
            internalType: "string[][]",
            name: "daoActionRoles",
            type: "string[][]",
          },
        ],
        internalType: "struct IDAOFactory.CreateDAOParams",
        name: "createDAOParams",
        type: "tuple",
      },
      {
        internalType: "address[]",
        name: "moduleFactories",
        type: "address[]",
      },
      {
        internalType: "bytes[][]",
        name: "moduleFactoriesBytes",
        type: "bytes[][]",
      },
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "calldatas",
        type: "bytes[]",
      },
    ],
    name: "createDAOAndExecute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type MetaFactoryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MetaFactoryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MetaFactory__factory extends ContractFactory {
  constructor(...args: MetaFactoryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MetaFactory> {
    return super.deploy(overrides || {}) as Promise<MetaFactory>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): MetaFactory {
    return super.attach(address) as MetaFactory;
  }
  override connect(signer: Signer): MetaFactory__factory {
    return super.connect(signer) as MetaFactory__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MetaFactoryInterface {
    return new utils.Interface(_abi) as MetaFactoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MetaFactory {
    return new Contract(address, _abi, signerOrProvider) as MetaFactory;
  }
}
